// Plan Content Map Keys
export const OFFER_PLAN_NAME = "OFFER_PLAN_NAME";
export const DURATION_COUNT = "DURATION_COUNT";
export const DURATION_LABEL = "DURATION_LABEL";
export const PLAN_PRICE = "PLAN_PRICE";
export const SPECIAL_OFFER = "SPECIAL_OFFER";
export const MODAL_DESCRIPTION = "MODAL_DESCRIPTION";
export const STARTER_FEE_SUBLABEL = "STARTER_FEE_SUBLABEL";
export const RAMP1_MEDS_SUBLABEL = "RAMP1_MEDS_SUBLABEL";
export const RAMP1_MEDS_SALE_PRICE = "RAMP1_MEDS_SALE_PRICE";
export const SALES_PITCH = "SALES_PITCH";
export const TOTAL_SUBLABEL = "TOTAL_SUBLABEL";
export const RAMP1_MEDS_RETAIL_PRICE = "RAMP1_MEDS_RETAIL_PRICE";
export const RAMP2_MEDS_SALE_PRICE = "RAMP2_MEDS_SALE_PRICE";
export const CONSULT_FEE_LABEL = "CONSULT_FEE_LABEL";
export const CONSULT_FEE_SUBLABEL = "CONSULT_FEE_SUBLABEL";
export const TOTAL_LABEL = "TOTAL_LABEL";
export const TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS";
export const TERMS_AND_CONDITIONS_ADDENDUM = "TERMS_AND_CONDITIONS_ADDENDUM";

// Plan Custom Fields
export const SUBSCRIPTION_TYPE = "subscriptionType";
export const OWNER_ID = "ownerId";

// Misc
export const TEMP_MEDS_SUBLABEL = "TEMP_MEDS_SUBLABEL";
export const CLINICAL_ADDON_CODE = "clinical-consultationfee";
export const SUCCESS = "SUCCESS";
export const RECURLY = "RECURLY";
export const B2B = "b2b";
export const B2C = "b2c";
export const WW_OWNER_ID = "37";
export const MONTH = "month";
export const MO = "mo";

// Compound Checkout
export const COMPOUND = "compound";
export const WEGOVY = "wegovy";
export const INSURANCE = "insurance";
export const CLINICIAN = "clinician";
export const NONE = "none";
export const BUNDLE_ID = "bundleId";
export const TREATMENT = "treatment";
export const COMPOUNDED_SEMAGLUTIDE_ITEM = "compounded-semaglutide-item";
export const COMPOUNDED_SEMAGLUTIDE_ITEM_V2 = "compounded-semaglutide-item-v2";
export const COMPOUNDED_SEMAGLUTIDE_USAGE_BASED_ADDON =
  "compounded-semaglutide-usage-based-addon";

// Coupon States
export const COUPON_REDEEMABLE = "redeemable";
